import { render } from "./SimpleWizard.vue?vue&type=template&id=1d7e7564"
import script from "./SimpleWizard.vue?vue&type=script&lang=js"
export * from "./SimpleWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__